export enum FilterCustomerOption {
    all = 'All',
    match = 'Matched',
    notMatched = 'Not matched',
    ignored = 'Ignored',
}
